const ClosingPhraseSection = () => {
  return (
    <section className="py-20 sm:py-28 px-6 bg-[#E8D2B5]/40">
      <div className="max-w-2xl mx-auto text-center space-y-10">
        <div className="w-16 h-[1px] bg-[#C5A059]/30 mx-auto" />
        
        <p 
          className="font-serif text-lg sm:text-xl text-[#3F2A24]/80 leading-[2.2] whitespace-pre-line"
          style={{ textWrap: 'balance' }}
        >
          {"COCON n'est pas une retraite de plus.\nC'est un passage."}
        </p>
        
        <div className="w-8 h-[1px] bg-[#C5A059]/30 mx-auto" />
        
        <p 
          className="font-serif text-base sm:text-lg text-[#3F2A24] italic leading-[2]"
          style={{ textWrap: 'balance' }}
        >
          {"Et parfois, il suffit d'un lieu et d'un cercle\npour que ce passage devienne possible."}
        </p>
      </div>
    </section>
  );
};

export default ClosingPhraseSection;
